import { stylesheet } from '@/features/ui/buttons/components/IconButton/styles'
import { IconButtonProps } from '@/features/ui/buttons/components/IconButton/types'
import { getElementColor } from '@/features/ui/buttons/components/IconButton/utils'
import { ButtonStateEnum } from '@/features/ui/buttons/constants'
import { useEnabledButtonState } from '@/features/ui/buttons/hooks/useEnabledButtonState'
import { FC } from 'react'
import { Pressable } from 'react-native'
import { useStyles } from 'react-native-unistyles'

const IconButton: FC<IconButtonProps> = ({
    disabled = false,
    mode = 'squared',
    type = 'default',
    color = 'primary',
    size = 40,
    iconSize = 24,
    Icon,
    onPress,
    accessibilityLabel,
    accessibilityRole,
    style,
    testID,
}) => {
    const { state: enabledState, eventHandlers } = useEnabledButtonState()

    const { styles } = useStyles(stylesheet)

    const state = disabled ? ButtonStateEnum.Disabled : enabledState

    return (
        <Pressable
            disabled={disabled}
            onPress={onPress}
            accessibilityLabel={accessibilityLabel}
            accessibilityRole={accessibilityRole}
            {...eventHandlers}
            style={[styles.container, styles.containerExtra(mode, type, state, color, size), style]}
            testID={testID}
        >
            <Icon fill={getElementColor(type, state, color)} height={iconSize} width={iconSize} />
        </Pressable>
    )
}

export default IconButton
